__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-30-1790768028-stable-dev/";